export default "__VITE_ASSET__C0nVZ0pq__"